import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'

const projectName = '/api/blade-platform';
const projectNameNew  = '/api/blade-workbench';

const serviceList = {
  state: {
    dictList: null,
  },
  mutations: {
    SET_ServiceList_dictList(state, result) {
      const st = state;
      st.dictList = result;
    },
  },
  actions: {
    /**
     * 查询服务列表
     * @param {*} param0 context
     */
    serviceInfoList({ commit }, data) {
      return request({
        url: `${projectName}/serviceInfo/list`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 新增或者修改服务信息
     * @param {*} param0 context
     */
    serviceInfoSubmit({ commit }, data) {
      return request({
        url: `${projectName}/serviceInfo/submit`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 状态更新:上架/下架
     * @param {*} param0 context
     */
    serviceUpdateStatus({ commit }, data) {
      return request({
        url: `${projectName}/serviceInfo/updateStatus`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 删除服务
     * @param {*} param0 context
     */
    serviceRemoveData({ commit }, data) {
      return request({
        url: `${projectName}/serviceInfo/remove`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 获取字典列表下拉列表
     * @param {*} param0 context
     */
    dictList({ commit }, data) {
      return request({
        url: `${projectName}/dict/list`,
        method: 'get',
      }).then((res) => {
        commit('SET_ServiceList_dictList', res.data.result)
        return Promise.resolve(res);
      });
    },
    /**
     * 查询场景列表
     * @param {*} param0 context
     */
    serviceSceneList({ commit }, data) {
      return request({
        url: `${projectName}/serviceScene/list`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 删除服务场景
     * @param {*} param0 context
     */
    serviceSceneRemove({ commit }, data) {
      return request({
        url: `${projectName}/serviceScene/remove`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 新增或者修改服务场景
     * @param {*} param0 context
     */
    serviceSceneSubmit({ commit }, data) {
      return request({
        url: `${projectName}/serviceScene/submit`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 获取上架标记下拉框
     * @param {*} param0 context
     */
    serviceShelfLabel({ commit }, data) {
      return request({
        url: `${projectName}/baseService/getShelfLabel`,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 获取角色树
     * @param {*} param0 context
     */
    getServiceRoleList({ commit }, data) {
      return request({
        url: `${projectName}/baseService/getRoleList`,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    /**
     * 获取标签树
     * @param {*} param0 context
     */
    getServiceEduLableList({ commit }, data) {
      return request({
        url: `${projectName}/baseService/getEduLableList`,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    //=========================================================V1.3.2APi
    /**
     * 获取校友圈配置
     * @param {*} param0 context
     */
     getAlumniMomentsConfig({ commit }, data) {
        return request({
          url: `${projectName}/appconfiguration/getAlumniMomentsConfig`,
        }).then((res) => {
          return Promise.resolve(res);
        });
      },
      //=========================================================V1.3.2校友圈启用
       /**
     * 保存校友圈设置
     * @param {*} param0 context
     */
        GetCurrentTableData({ commit }, data) {
        return request({
          url: `${projectName}/appconfiguration/AlumniMomentTile/list`,
          method: 'get',
        }).then((res) => {
          return Promise.resolve(res);
        });
      },
      /**
     * 保存校友圈设置
     * @param {*} param0 context
     */
     saveAlumniMomentConfig({ commit }, data) {
        return request({
          url: `${projectName}/appconfiguration/saveAlumniMomentConfig`,
          method: 'post',
          data,
        }).then((res) => {
          return Promise.resolve(res);
        });
      },
    //新增校友圈栏目
    AlumniMomentTitleAdd(actions, data) {
        return request({
            url: `${projectName}/appconfiguration/AlumniMomentTitle/add`,
            method: 'post',
            data
        });
    },
    //修改校友圈栏目
    AlumniMomentTitleUpdate(actions, data) {
        return request({
            url: `${projectName}/appconfiguration/AlumniMomentTitle/update`,
            method: 'post',
            data
        });
    },
    //删除校友圈栏目
    AlumniMomentTitleRemove(actions, data) {
        return request({
            url: `${projectName}/appconfiguration/AlumniMomentTitle/remove`,
            method: 'post',
            data
        });
    },
    //=========================================================V1.3.2APi12.17
    // 查询在校生院/专/班
    getCollegeMajorTree(actions, data) {
        return request({
            url: `${projectNameNew}/eduClassInfo/getCollegeMajorTree`,
            method: 'post',
            data
        });
    },
    // 查询新生院/专/班
    newStudentOranization() {
        return request({
            url: `${projectNameNew}/edunewstudentinfo/newStudentOranization`,
            method: 'get'
        });
    },
    //单位
    getEduDeptInfoTree(actions, data) {
        return request({
            url: `${projectNameNew}/eduteacherinfo/getEduDeptInfoTree`,
            method: 'post',
            data
        });
    },
    //查询电子证件配置用户列表数据,根据参数判断不同身份类型
    userList(actions, data) {
        return request({
            url: `${projectName}/userImg/userList`,
            method: 'post',
            data
        });
    },
    //咨询配置禁用
    enable(actions, data) {
        return request({
            url: `${projectName}/newsSectionConfig/enable`,
            method: 'post',
            data
        });
    },
    //咨询配置立即同步
    handSyn(actions, data) {
        return request({
            url: `${projectName}/newsSectionConfig/handSyn`,
            method: 'post',
            data
        });
    },
    // 查询电子证件配置圆弧列表数据,删除列表数据照片(/userImg前缀)
    deleteImg(actions, data) {
        return request({
            url: `${projectName}/userImg/deleteImg`,
            method: 'post',
            data
        });
    },
    // 查询电子证件用户照片上传方式
    getConfig(actions, data) {
        return request({
            url: `${projectName}/userImg/getConfig`,
            method: 'post',
            data
        });
    },
    // 查询选中单位下的子级单位id
    getEduDeptInfoTreeByDeptId(actions, data) {
        return request({
            url: `${projectNameNew}/eduteacherinfo/getEduDeptInfoTreeByDeptId`,
            method: 'post',
            data
        });
    },
    // 查询电子证件用户照片上传方式
    checkExportImg(actions, data) {
        return request({
            url: `${projectName}/userImg/checkExportImg`,
            method: 'post',
            data
        });
    },
    // 查询电子证件用户照片上传方式
    excelCheckExportImg(actions, data) {
        return request({
            url: `${projectName}/userImg/excel/checkExportImg`,
            method: 'post',
            data
        });
    },
     // 查询电子证件配置圆弧列表数据,删除列表数据照片(/userImg前缀)
     deleteAllImg(actions, data) {
        return request({
            url: `${projectName}/userImg/deleteAllImg`,
            method: 'post',
            data
        });
    },
    // 查询电子证件配置圆弧列表数据,导入
    importImg(actions, data) {
        return request({
            url: `${projectName}/userImg/importImg`,
            method: 'post',
            data
        });
    },
    // 查询电子证件配置圆弧列表数据,导出
    exportImg(actions, data) {
        return request({
            url: `${projectName}/userImg/exportImg`,
            method: 'post',
            data,
            responseType: 'blob'
        });
    },
    // 查询电子证件配置圆弧列表数据,导出
    exportImgCount(actions, data) {
        return request({
            url: `${projectName}/userImg/exportImgCount`,
            method: 'post',
            data
        });
    },
  },
};

export default serviceList;
